var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.12 1.875H7.907c-.43 0-.718.29-.718.868v4.484H2.737c-.575 0-.862.29-.862.723v13.307c0 .434.287.868.862.868H15.95c.43 0 .861-.434.861-.868v-4.484h4.452c.431 0 .862-.29.862-.868V2.743c-.144-.579-.575-.868-1.005-.868zm-6.032 18.37c0 .144-.144.289-.287.289H3.742c-.144 0-.287-.145-.287-.29V9.108c0-.144.143-.29.287-.29H14.8c.144 0 .288.146.288.29v11.138zm5.314-5.352c0 .144-.144.29-.288.29h-3.16c-.143 0-.286-.146-.286-.29V7.95c0-.434-.288-.868-.862-.868h-6.75c-.144 0-.287-.144-.287-.29V3.756c0-.144.143-.289.287-.289h11.058c.144 0 .288.145.288.29v11.137z",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesInactive);
export default __webpack_public_path__ + "static/media/pages_inactive.a956f6fe0ef403845105e3c373e4a37a.svg";
export { ForwardRef as ReactComponent };